import styles from "./Loader.module.css"; // Import styles as object

const Loader = () => {
  return (
    <div className={styles.loaderOverlay}>
      <div className={styles.spinner} />
    </div>
  );
};

export default Loader;
